<template>
  <div class="card">
    <Card dis-hover shadow :padding="0">

      <div class="title-box">
        <div class="title">
          <span class="text1">用户评价</span>
        </div>
      </div>
      <div class="item-wrapper" style="padding-bottom:20px">
        <div class="text2">综合评价</div>
        <div class="box v-center">
          <Rate v-if="scoreInfo.score" show-text disabled allow-half v-model="scoreInfo.score">
            <span class="score-num">{{scoreInfo.score}}分</span>
          </Rate>
          <div class="score-people">({{scoreInfo.people}}位用户评价)</div>
        </div>
      </div>
      <div class="text3">全部评价</div>
        <div class="pingjia-wrapper">
        <!--<Scroll :on-reach-bottom="getMorePingjia" height="300">-->

        <div v-if="isNodata" class="no-pingjia">暂无评价</div>
        <div v-else v-for="(item,index) in pingjia" :key="item.id" class="item-wrapper box" :id="index==0?'first':''">
          <div>
            <Rate v-if="item.score" disabled allow-half v-model="item.score"/>
            <div class="item-content">{{item.content}}</div>
            <div class="box pinglun-picWrapper">
              <div class="pic-box" v-for="(_item,_index) in item.picList"
                   :key="_index">
                <img
                  :src="_item"
                  class="pinglun-pic"
                  @click="modalShow2(_index,item.picList)"
                >
              </div>
            </div>
            <div class="box item-footer">
              <div>{{item.time}}</div>
              <div class="delete" @click="delPingjia(index)">删除</div>
            </div>
          </div>
          <div class="box box_v" style="align-items: center">
            <img :src="item.headPic" class="head-pic">
            <div class="item-name">{{item.name}}</div>
          </div>
        </div>
        <!--</Scroll>-->
      </div>
      <Page v-if="pingjia.length" class="page" :total="total" @on-change="changePingjia"/>
    </Card>
    <preview-img
      v-if="isShowImg"
      :imgArr="imgArr"
      :currentIndex="currentIndex"
      v-on:closePreview="closePreview"
    ></preview-img>
  </div>
</template>

<script>
  import previewImg from "../../../components/previewImg";
  var that

  export default {
    props: {
      scoreInfo: null,
      companyId: null
    },
    components: {
      previewImg,
    },
    data() {
      return {
        paddding: 0,
        isShowImg: false,
        currentIndex: 0,
        imgArr: [],
        pingjia: [],
        page: 1,
        rows: 10,
        isNodata: false,
        total: 0
      };
    },
    watch: {
      companyId() {
        that.getPingjia()
      }
    },
    methods: {
      getPingjia() {
        return new Promise((resolve, reject) => {
          var url = this.urlobj.getQyPingjia;
          this.$post(url, {
            comeId: that.companyId,
            comeType: 3,
            pageNum: that.page,
            pageSize: that.rows
          }).then(res => {
            if (that.page ==1 && !res.rows.length) that.isNodata = true;
            this.total = res.total
            var pingjia = res.rows.map(item => {
              return {
                headPic: item.headPicUrl,
                name: item.userName,
                picList: item.picUrlList,
                score: item.score / 100,
                content: item.message || "该用户未填写任何评价",
                time: item.createTime.replace(/\.0/g, ""),
                id: item.id
              };
            });
            that.pingjia = pingjia;
            document.getElementById("first") && document.getElementById("first").scrollIntoView();
            resolve(res);
          }).catch(e => reject(e));
        });
      },
      changePingjia(value) {
        this.page = value
        this.getPingjia()
      },
      modalShow2(index, list) {
        //预览
        var _list = list.map((item, _index) => {
          return {
            id: _index,
            path: item,
            isHeight: 1
          };
        });
        var img1 = _list.slice(0, index);
        var img2 = _list.slice(index);
        this.currentIndex = index;
        this.imgArr = img2.concat(img1);
        this.isShowImg = true;
      },
      closePreview() {
        this.isShowImg = false;
      },
      delPingjia(index) {
        var length = this.pingjia.length
        var url = this.urlobj.delPingjia;
        var id = this.pingjia[index].id;
        this.$post(url, {id}).then(res => {
          if (res.isSucceed) {
            //删除的是本页最后一条
            if (length == 1 && this.page>1) {
              this.page--
            }
            this.getPingjia()
            this.$Message.success('删除成功')
          }else {
            this.$Message.error('删除失败')
          }
        }).catch(e => {
          this.$Message.error('删除失败')
        });
      }
    },
    mounted() {
      that = this
    }
  };
</script>

<style scoped>
  .v-center {
    align-items: center;
  }

  .mar-btm30 {
    margin-bottom: 30px;
    align-items: center;
  }

  .card {
    width: 97%;
  }

  .title-box {
    border-bottom: 1px solid #ddd;
  }

  .title {
    padding: 20px 0 0 20px;
    text-align: left;
    margin-bottom: 20px;
  }

  .text1 {
    font-size: 20px;
    color: #333;
    padding-right: 10px;
    font-weight: 600;
  }

  .item-wrapper {
    border-bottom: 1px solid #ddd;
    margin-left: 20px;
    padding: 20px 30px 0 0;
    justify-content: space-between;
    align-items: center;
  }
  .item-wrapper:first-child{
    padding-top: 0
  }
  .score-num {
    color: #333;
    font-size: 16px;
    padding-bottom: 5px;
    display: inline-block;
  }

  .score-people {
    color: #999;
    margin-left: 30px;
  }

  .pingjia-wrapper {
    max-height: 500px;
    overflow-y: scroll;
  }
  .pingjia-wrapper::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  }

  .pingjia-wrapper::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
    background: #dddddd;
  }

  .text2 {
    color: #333;
    font-size: 17px;
    margin-bottom: 5px;
  }
  .text3 {
    color: #333;
    font-size: 17px;
    margin-bottom: 5px;
    margin-left:20px;
    padding:20px 0
  }
  .pinglun-picWrapper {
    flex-wrap: wrap;
    margin-top: 15px;
  }

  .pic-box {
    height: 75px;
    width: 75px;
    margin: 0 20px 20px 0;
    display: -webkit-box;
    -webkit-box-pack:center;
    -webkit-box-align:center;
    -webkit-box-orient: vertical;
  }

  .pinglun-pic {
    /*height: 75px;*/
    /*width: 75px;*/
    /*margin: 0 20px 20px 0;*/
    max-width: 100%;
    width: auto;
    max-height: 100%;
    height: auto;
  }

  .item-content {
    color: #999;
    font-size: 16px;
    margin-bottom: 20px;
    margin-top: 5px;
  }

  .item-footer {
    color: #999;
    font-size: 16px;
  }

  .delete {
    color: #667a9f;
    margin-left: 20px;
    cursor: pointer;
  }

  .head-pic {
    height: 60px;
    width: 60px;
    border-radius: 50%;
  }

  .item-name {
    color: #4a4a4a;
    margin-top: 10px;
  }

  .no-pingjia {
    font-size: 32px;
    color: #999;
    text-align: center;
    padding-bottom: 30px;
  }

  .page {
    text-align: center;
    padding: 20px 0;
    border-top: 1px solid #ddd;
  }
</style>
